import { type HotkeyManager, type SequenceManager, getHotkeyManager, getSequenceManager } from '@tanstack/hotkeys';

const HOTKEY_MANAGER_KEY = 'ingkaHotkeyManager' as const;
const SEQUENCE_MANAGER_KEY = 'ingkaSequenceManager' as const;

declare global {
    var ingkaHotkeyManager: HotkeyManager | undefined;
    var ingkaSequenceManager: SequenceManager | undefined;
}

export const getSharedHotkeyManager = (): HotkeyManager => {
    globalThis[HOTKEY_MANAGER_KEY] ??= getHotkeyManager();
    return globalThis[HOTKEY_MANAGER_KEY];
};

export const getSharedSequenceManager = (): SequenceManager => {
    globalThis[SEQUENCE_MANAGER_KEY] ??= getSequenceManager();
    return globalThis[SEQUENCE_MANAGER_KEY];
};
